import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ROUTE_CONSTANT } from "../../routing/route-constants";

const allowedRoutesToDisplayOlark = [
  ROUTE_CONSTANT.LOGIN,
  ROUTE_CONSTANT.DASHBOARD,
  ROUTE_CONSTANT.SETTINGS,
];

const OlarkHandler = () => {
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;

    if (allowedRoutesToDisplayOlark.includes(currentPath)) {
      // Show Olark chat widget on allowed routes
      window.olark?.("api.box.show");
    } else {
      // Hide Olark chat widget on other routes
      window.olark?.("api.box.hide");
    }

    // Cleanup function to ensure Olark box visibility is reset when the component unmounts
    return () => {
      window.olark?.("api.box.show");
    };
  }, [location]);

  return null; // This component handles side effects only
};

export default OlarkHandler;
